export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-layout-52c40f30dfd0c947ec8b33dd35b92247.svg";